import axios from '@/libs/api.request'

export const getPcb = (id) => {
  return axios.request({
    url: `parts/circuit-board/${id}`,
    method: 'get'
  })
}

export const getPcbSpecValues = (id) => {
  return axios.request({
    url: `parts/circuit-board/${id}/specs`,
    method: 'get'
  })
}

export const savePcbSpecValues = (id, data) => {
  return axios.request({
    url: `parts/circuit-board/${id}/specs`,
    method: 'post',
    data
  })
}

export const getAllPcbs = () => {
  return axios.request({
    url: 'parts/circuit-board',
    method: 'get'
  })
}

export const createPcb = (data) => {
  return axios.request({
    url: 'parts/circuit-board/create',
    method: 'post',
    data
  })
}

export const updatePcb = (id, data) => {
  return axios.request({
    url: `parts/circuit-board/${id}`,
    method: 'put',
    data
  })
}

export const deletePcb = (id) => {
  return axios.request({
    url: `parts/circuit-board/${id}`,
    method: 'delete'
  })
}

export const getChangeLogs = (id) => {
  return axios.request({
    url: `parts/circuit-board/${id}/changes`,
    method: 'get'
  })
}

export const getPcbCostsByPcb = (pcbId) => {
  return axios.request({
    url: `parts/circuit-board/${pcbId}/cost-estimates`,
    method: 'get'
  })
}

export const createPcbCost = (data) => {
  return axios.request({
    url: `pcb/cost-estimates`,
    method: 'post',
    data
  })
}

export const deletePcbCost = (id) => {
  return axios.request({
    url: `pcb/cost-estimates/${id}`,
    method: 'delete'
  })
}

export const getPcbByName = (boardName) => {
  return axios.request({
    url: `/pcb/part-specifications/${boardName}`,
    method: 'get'
  })
}

export const calculatePcbPrice = (pcbId, data) => {
  return axios.request({
    url: `/calculate/pcb-cost/${pcbId}`,
    method: 'post',
    data
  })
}

export const getPcbCalculate = (quoteId) => {
  return axios.request({
    url: `/pcb/cost-estimates/${quoteId}`,
    method: 'get'
  })
}

export const savePcbCalculate = (id, data) => {
  return axios.request({
    url: `/pcb/cost-estimates/${id}`,
    method: 'put',
    data
  })
}

export const createPcbCalculate = (data) => {
  return axios.request({
    url: `/pcb/cost-estimates`,
    method: 'post',
    data
  })
}

export const getCalculateHistory = (pcbId) => {
  return axios.request({
    url: `/pcb/cost-estimates/pcb-cost-calculate-history/${pcbId}`,
    method: 'get'
  })
}

export const getPcbCostByID = (id) => {
  return axios.request({
    url: `/pcb/cost-estimates/${id}`,
    method: 'get'
  })
}

export const getPcbList = (data) => {
  return axios.request({
    url: `/pcb/cost-estimates`,
    method: 'get',
    params: data
  })
}

export const deletePcbListInfo = (pcbId) => {
  return axios.request({
    url: `/pcb/cost-estimates/${pcbId}`,
    method: 'delete'
  })
}
